// Сумата на сметка в списъците за избор на сметки за фактура („Маркиране" →
// Фактуриране и „История на операциите" → Фактура).
//
// Фактурата носи поръчаното И записания бакшиш, затова сметка с бакшиш
// показва сумата за фактуриране (поръчано + бакшиш) и под нея тихо
// „вкл. бакшиш X". Сметка без бакшиш показва ТОЧНО досегашния текст.

import { useTranslation } from "react-i18next";

import type { BillHistory } from "../../../../../api/reportsBillsHistory";
import { billTipCentsOf } from "../../../../../lib/billTips";
import { formatCents, parseMoneyToCents } from "../../../../../utils/money";

type Props = {
  bill: Pick<BillHistory, "total_amount" | "tip_amount">;
  /** Форматът на сумата в съответния списък. */
  formatMoney: (value: number | string) => string;
};

export const InvoiceBillAmount = ({ bill, formatMoney }: Props) => {
  const { t } = useTranslation();
  const tipCents = billTipCentsOf(bill);
  if (tipCents <= 0) return <>{formatMoney(bill.total_amount)}</>;

  const invoicedCents = (parseMoneyToCents(bill.total_amount) ?? 0) + tipCents;
  return (
    <>
      {formatMoney(formatCents(invoicedCents))}
      <span className="block text-[11px] font-medium text-pos-muted">
        {t("invoiceTips.pickerIncludesTip", {
          amount: formatMoney(formatCents(tipCents)),
        })}
      </span>
    </>
  );
};
